import { PureComponent } from "react";

import { componentStyles } from "./videos-gallery-component.scss";

import VideoThumbnailItemComponent from "/components/core/thumbnails/video-thumbnail-item/video-thumbnail-item-component";

import YoutubeVideoModalComponent from "/components/core/youtube-video-modal/youtube-video-modal-component";
import { VIDEO_OPTS } from "constants/youtube-modal";

export default class VideosGalleryComponent extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      showVideo: false,
      activeVideoIndex: null
    };

    this.onVideoThumbnailClick = this.onVideoThumbnailClick.bind(this);
    this.onCloseVideoModal = this.onCloseVideoModal.bind(this);
    this.renderVideoItem = this.renderVideoItem.bind(this);
  }

  onVideoThumbnailClick(activeVideoIndex) {
    this.setState({ showVideo: true, activeVideoIndex });
  }

  onCloseVideoModal() {
    this.setState({ showVideo: false });
  }

  getCurrentVideo() {
    const { videos } = this.props;
    const { activeVideoIndex } = this.state;

    return videos[activeVideoIndex];
  }

  renderVideoItem(video, index) {
    return <VideoThumbnailItemComponent key={index} index={index} {...video} onClick={this.onVideoThumbnailClick} />;
  }

  render() {
    const { title, videos } = this.props;
    const { showVideo } = this.state;

    const activeVideo = this.getCurrentVideo();

    return (
      <div className="videos-gallery-component">
        <div className="videos-gallery-title" dangerouslySetInnerHTML={{ __html: title }} />

        <div className="videos-list-wrapper">{videos.map(this.renderVideoItem)}</div>

        {showVideo && (
          <YoutubeVideoModalComponent
            videoId={activeVideo.videoId}
            footerText={activeVideo.videoFooterText}
            minHeight={546}
            isOpen={true}
            opts={VIDEO_OPTS}
            onCloseModal={this.onCloseVideoModal}
          />
        )}

        <style jsx>{componentStyles}</style>
      </div>
    );
  }
}
